module.exports = __webpack_public_path__ + "img/circle-checkbox-tick.4288448.svg";